import {
    GET_SHARE_TEMPLATE,
    UPDATE_TEMPLATE_DETAILS,
    DELETE_TEMPLATE,
    MORE_CREATE_PRODUCT_TEMPLATE,
    LIST_SHARE_USER,
    GET_SEARCH_PARAM,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    SET_EXPANDED_FILTER_VIEW,
    SET_PRODUCTSTEMPLATESFILTER,
    GET_CATEGORY_NAME,
    SET_TEMPLATE_PAGE_DETAILS,
    GET_USER_LIST,
    MORE_TEMPLATES_VALIDATE_PRODUCTS_SURGERY,
    CLEAR_VALIDATED_PRODUCTS_SURGERY,
    MORE_TEMPLATES_VALIDATE_PRODUCTS_EQUITY,
    CLEAR_VALIDATED_PRODUCTS_EQUITY,
    GET_TEMPLATE_DETAILS,
    CLEAR_TEMPLATE_PAGE_DETAILS,
    TYPE_FILTER_HANDLE,
    TEMPLATE_FLAG,
    GET_FILTER_SEARCH_DATA,
    SET_FILTER_DATA,
    CLEAR_SEARCH_FILTER,
    SEARCH_PARAM,
    SET_SELECTED_USER_INFO,
    SET_SELECTED_USER,
    SET_MAST_ORDER_TEMPLATE,
    SET_PRODUCT_TO_BE_ADDED,
    MORE_RESET_CREATE_TEMPLATE,
    RESET_UPDATE_TEMPLATE_DETAILS,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

export const templateFlag = (data) => {
    return {
        type: TEMPLATE_FLAG,
        payload: data,
    };
};

export const setData = (data) => {
    return {
        type: SET_PRODUCT_TO_BE_ADDED,
        payload: data,
    };
};

export const typeFilterHandle = (data) => {
    return {
        type: TYPE_FILTER_HANDLE,
        payload: data,
    };
};

export const getCategoryName = (data) => {
    return {
        type: GET_CATEGORY_NAME,
        payload: data,
    };
};

export const setProductsTemplatesFilter = (productsTemplatesFilter) => {
    return {
        type: SET_PRODUCTSTEMPLATESFILTER,
        payload: productsTemplatesFilter,
    };
};

export const getSearchParam = (data) => {
    return {
        type: GET_SEARCH_PARAM,
        payload: data,
    };
};

export const postShareTemplates = (data) => {
    return {
        type: GET_SHARE_TEMPLATE,
        payload: data,
    };
};

export const listShareUser = (data) => {
    return {
        type: LIST_SHARE_USER,
        payload: data,
    };
};

export const setSelectedUser = (data) => {
    return {
        type: SET_SELECTED_USER,
        payload: data,
    };
};

export const setSelectedUserInfo = (data) => {
    return {
        type: SET_SELECTED_USER_INFO,
        payload: data,
    };
};

export const updateTemplateDetails = (params, value) => {
    return {
        type: UPDATE_TEMPLATE_DETAILS,
        payload: params,
        carrierValue: value,
    };
};

export const setDeleteTemplate = (data) => {
    return {
        type: DELETE_TEMPLATE,
        payload: data,
    };
};

export const createTemplate = (params) => {
    return {
        type: MORE_CREATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const getDetailedProductTemplateList = (params) => {
    return {
        type: GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        payload: params,
    };
};

export const setExpandedFilters = (data) => {
    return {
        type: SET_EXPANDED_FILTER_VIEW,
        payload: data,
    };
};

export const setTemplateChangeDetails = (params) => {
    return {
        type: SET_TEMPLATE_PAGE_DETAILS,
        payload: params,
    };
};

export const clearTemplateDetails = () => {
    return {
        type: CLEAR_TEMPLATE_PAGE_DETAILS,
    };
};

export const getUserList = (params) => {
    return {
        type: GET_USER_LIST,
        payload: params,
    };
};

export const validateProductsSurgery = (products) => {
    return {
        type: MORE_TEMPLATES_VALIDATE_PRODUCTS_SURGERY,
        payload: products,
    };
};

export const clearValidatedProductsSurgery = () => {
    return {
        type: CLEAR_VALIDATED_PRODUCTS_SURGERY,
    };
};

export const resetCreateTemplate = () => {
    return {
        type: MORE_RESET_CREATE_TEMPLATE,
    };
};

export const resetUpdateTemplateDetails = () => {
    return {
        type: RESET_UPDATE_TEMPLATE_DETAILS,
    };
};


export const validateProductsEquity = (products) => {
    return {
        type: MORE_TEMPLATES_VALIDATE_PRODUCTS_EQUITY,
        payload: products,
    };
};

export const clearValidatedProductsEquity = () => {
    return {
        type: CLEAR_VALIDATED_PRODUCTS_EQUITY,
    };
};

export const getTemplateDetails = (params, tempcategory) => {
    return {
        type: GET_TEMPLATE_DETAILS,
        payload: params,
        templatecategory: tempcategory,
    };
};

export const getFilterSearchData = (params) => {
    return {
        type: GET_FILTER_SEARCH_DATA,
        payload: params,
    };
};

export const setFilterData = (filterType, filters) => {
    return {
        type: SET_FILTER_DATA,
        payload: { filterType, filters },
    };
};

export const clearSearchFilter = () => {
    return {
        type: CLEAR_SEARCH_FILTER,
    };
};

export const setSearchParam = (params) => {
    return {
        type: SEARCH_PARAM,
        payload: params,
    };
};

export const setMastOrderTemplate = (value) => {
    return {
        type: SET_MAST_ORDER_TEMPLATE,
        payload: value,
    };
};
